import React from "react";
import {WizTableForm} from '@/containers/common'
import {mergeColumns} from '../../utils';
import moment from "moment";

const program = WizTableForm.Config.program(this, {apiParams: {isPower: true}})
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}
const position = WizTableForm.Config.position(this, {apiParams: {state: 1}})
const user = WizTableForm.Config.user(this, {apiParams: {state: 1}})

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
let formatTime = (time) => {
  // 转换为时分秒
  let h = parseInt(time / 60 / 60 % 24)
  let m = parseInt(time / 60 % 60)
  let s = parseInt(time % 60)
   let res = ''
   if (h > 0) {res += `${h}时`};
   if (m > 0) {res += `${m}分`};
   if (s > 0) {res += `${s}秒`};
  return res
}
//配置项
const componentName = "programReport";

function columns() {
  const columns = [
    {
      name: "id",
    },
    {
      title: "课程名称",
      name: "programId",
      searchItem: {
        ...program,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择课程名称'
          }
        ]
      },
    },
    {
      title: "课程名称",
      name: "programName",
      tableItem: {},
    },

    {
      title: "课程编码",
      name: "scoId",
      tableItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryName",
      tableItem: {
        type: 'popover'
      },
    },
    {
      title: "归属部门",
      name: "programSource",
      dataIndex: "programSource",
      tableItem: {},
      searchItem: {},
    },
    {
      title: "课程状态",
      name: "status",
      tableItem: {},
      dict: [
        {code: 0, codeName: '草稿'},
        {code: 1, codeName: '发布'},
        {code: 2, codeName: '关闭'},
      ]
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    // {
    //   title: "学员身份证",
    //   name: "idCard",
    //   tableItem: {},
    // },
    {
      title: "账号状态",
      name: "accountState",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        {code: 0, codeName: '禁用'},
        {code: 1, codeName: '激活'},
      ]
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
        onChangeRowMap: (e) => {},
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryIds",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        treeCheckable: true
      }
    },
    {
      title: "省份",
      name: "province",
      dataIndex: "province",
      tableItem: {},
      searchItem: {
      },
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      tableItem: {},
      dict: [
        {code: 0, codeName: '离职'},
        {code: 1, codeName: '在职'},
      ]
    },
    {
      title: "课程完成率",
      name: "finishRate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "通过状态",
      name: "pass",
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: '未通过'},
        {code: 1, codeName: '通过'},
      ]
    },
    {
      title: "开始学习时间",
      name: "firstTime",
      dataIndex: "firstTime",
      tableItem: {},
    },
    {
      title: "开始学习时间",
      name: "programDate",
      dataIndex: "programDate",
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: "末次学习时间",
      name: "lastTime",
      tableItem: {},
    },
    {
      title: '课程通过时间',
      name: 'passDate',
      dataIndex: "passDate",
      tableItem: {},
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: '学习时长',
      name: 'duration',
      dataIndex: "duration",
      tableItem: {
        render : (text,record) => {
          return formatTime(text)
        }
      },
    },
  ];

  return mergeColumns.call(this, columns, [])
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['programDate'] && value['programDate'].length === 2) {
              value['programStartDate'] = moment(value['programDate'][0]).format("YYYY-MM-DD HH:mm:ss")
              value['programEndDate'] = moment(value['programDate'][1]).format("YYYY-MM-DD HH:mm:ss")
            }else{
              value['programStartDate']= undefined;
              value['programEndDate'] = undefined;
            }
            if (value['passDate'] && value['passDate'].length === 2) {
              value['passStartDate'] = moment(value['passDate'][0]).format("YYYY-MM-DD HH:mm:ss")
              value['passEndDate'] = moment(value['passDate'][1]).format("YYYY-MM-DD HH:mm:ss")
            }else{
              value['passStartDate']= undefined;
              value['passEndDate'] = undefined;
            }
            return value
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageList`,
    payload: {
      key: `${componentName}@getPageList`,
      apiParams: {pageNum: 1, pageSize: 10},
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export {reduxTemplateCofig, templateConfig};
